import React, { memo, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Box } from '@mui/material';
import FormGenerator from '@sharedCR/common/formGenerator';
import { FormNames } from 'app/services/autoLockForms/autoLockForms.constants';

import { selectChattelDetails } from 'store/loanApplications/selectors';

import { defaultForm, pagesPropTypes } from '../MainContent.constants';
import { boxStyle } from '../MainContent.styles';

import { getChattelHomeDetailsConfig } from './ChattelHomeDetails.config';

const ChattelHomeDetails = ({
  isLoading,
  isSaving,
  form = defaultForm,
  validationErrors,
  validateField,
  handleChange,
  setEntityConfig,
  setInForm,
  className,
  applicationData,
  staticValidateField,
  pendingChanges,
  disabledPendingChangesHighlight,
}) => {
  // The purpose is edited on Loan Details and kept in the store; the condition is edited on this form.
  const { purposeOfChattel = null } = useSelector(selectChattelDetails) ?? {};
  const condition = form.condition?.value ?? applicationData?.condition ?? null;

  const config = useMemo(
    () => getChattelHomeDetailsConfig({ purposeOfChattel, condition }),
    [purposeOfChattel, condition],
  );

  useEffect(() => {
    setEntityConfig(config);
  }, [setEntityConfig, config]);

  return (
    <Box className={className}>
      <Box sx={boxStyle}>
        <FormGenerator
          isNestedForm
          config={config}
          disabledPendingChangesHighlight={disabledPendingChangesHighlight}
          form={form}
          formName={FormNames.CHATTEL_HOME_DETAILS}
          handleChange={handleChange}
          isLoading={isSaving || isLoading}
          numberOfColumns={4}
          pendingChanges={pendingChanges}
          setInForm={setInForm}
          staticValidateField={staticValidateField}
          validateField={validateField}
          validationErrors={validationErrors}
        />
      </Box>
    </Box>
  );
};

ChattelHomeDetails.propTypes = pagesPropTypes;

export default memo(ChattelHomeDetails);
